<template>
    <!-- Mobile backdrop -->
    <div
        v-if="mobileOpen"
        class="fixed inset-0 z-30 bg-black/50 lg:hidden"
        @click="emit('close')"
    />

    <aside
        class="fixed inset-y-0 left-0 z-40 flex w-64 flex-col border-r border-surface-200 bg-surface-0 transition-transform duration-200 lg:static lg:translate-x-0 dark:border-surface-800 dark:bg-surface-900"
        :class="mobileOpen ? 'translate-x-0' : '-translate-x-full'"
    >
        <!-- Brand -->
        <div class="flex h-16 items-center gap-3 px-5">
            <div class="flex size-9 shrink-0 items-center justify-center rounded-xl bg-primary-600 text-white shadow-sm shadow-primary-500/30">
                <i class="pi pi-shield text-lg" />
            </div>
            <span class="text-lg font-semibold tracking-tight text-surface-900 dark:text-surface-0">
                {{ $t('app.name') }}
            </span>
        </div>

        <!-- Nav -->
        <nav class="flex-1 space-y-1 overflow-y-auto px-3 py-2">
            <RouterLink
                v-for="item in navItems"
                :key="item.name"
                :to="{ name: item.name }"
                class="group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors"
                :class="isActive(item)
                    ? 'bg-primary-500/10 text-primary-600 dark:text-primary-300'
                    : 'text-surface-600 hover:bg-surface-100 hover:text-surface-900 dark:text-surface-400 dark:hover:bg-surface-800 dark:hover:text-surface-0'"
                @click="emit('close')"
            >
                <i :class="['pi', item.icon, 'text-base']" />
                <span class="truncate">{{ $t(item.key) }}</span>
            </RouterLink>
        </nav>
    </aside>
</template>

<script lang="ts" setup>
    import { RouterLink, useRoute } from 'vue-router'

    defineProps<{
        mobileOpen: boolean
    }>()

    const emit = defineEmits<{
        close: []
    }>()

    const route = useRoute()

    interface NavItem {
        name:  string
        key:   string
        icon:  string
        match: string[]
    }

    const navItems: NavItem[] = [
        { name: 'clients',      key: 'nav.clients',      icon: 'pi-building',   match: ['clients', 'client'] },
        { name: 'client-users', key: 'nav.client_users', icon: 'pi-id-card',    match: ['client-users', 'client-user'] },
        { name: 'support',      key: 'nav.support',      icon: 'pi-headphones', match: ['support'] },
        { name: 'admin-users',  key: 'nav.admin_users',  icon: 'pi-users',      match: ['admin-users'] },
        { name: 'audit',        key: 'nav.audit',        icon: 'pi-history',    match: ['audit'] },
    ]

    const isActive = (item: NavItem) => item.match.includes(route.name as string)
</script>
